import 'react';
import { BsCursor } from '@react-icons/all-files/bs/BsCursor';
import { BsCursorFill } from '@react-icons/all-files/bs/BsCursorFill';
import { decorateComponent } from '../../../documentComponents/decorateComponent.js';
import { TabButton as TabButton$1 } from './TabButton.js';
import { jsx } from '@emotion/react';

var TabButton = decorateComponent(TabButton$1, 'block', {
  id: 'tabButton',
  allowedParent: ['tabItem'],
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: function renderIcon(_ref) {
    var state = _ref.state;
    return state === 'on' ? jsx(BsCursorFill, null) : jsx(BsCursor, null);
  },
  renderTitle: function renderTitle(_ref2) {
    var state = _ref2.state;
    return "\uD0ED \uBC84\uD2BC ".concat(state);
  }
});

export { TabButton as default };
//# sourceMappingURL=index.js.map
